export const enterpriseEditionUrl = "https://www.openproject.org/enterprise-edition/?op_edition=community-edition";

export const contactUrl:{[locale:string]:string} = {
  en: "https://www.openproject.org/contact-us/",
  de: "https://www.openproject.org/kontakt/",
};
